import { functions } from '@/firebase';
import { Stripe } from 'stripe';

export async function getCheckoutSession(sessionId: string): Promise<Stripe.Checkout.Session> {
  const getCheckoutSessionFN = functions.httpsCallable('getCheckoutSession');
  const { data: session }: { data: Stripe.Checkout.Session } = await getCheckoutSessionFN(sessionId);

  return session;
}
